"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryParamsWhitelist = exports.overrideSuffix = void 0;
/**
 * Similar to the editor, -override is regarded as an internal query param - it should build the links with these params
 */
exports.overrideSuffix = '-override';
/*
 * The Viewer doesn't preserve query params on internal navigation.
 * THIS LIST IS FOR INTERNAL QUERY PARAM ONLY!
 * Don't add query params here to support any kind of product.
 * If a product needs query params to persist after navigation - it should build the links with these params,
 * */
exports.queryParamsWhitelist = new Set([
    'schemaDevMode',
    'currency',
    'ruiTrace',
    'metaSiteId',
    'isqa',
    'enableTestApi',
    'experiments',
    'experimentsoff',
    'suppressbi',
    'sampleratio',
    'hot',
    'viewerPlatformAppSources',
    'wixCodeForceKibanaReport',
    'controllersUrlOverride',
    'debug',
    'petri_ovr',
    'iswixsite',
    'showMobileView',
    'lang',
    'ssrDebug',
    'wixAdsOverlay',
    'ssrIndicator',
    'siteRevision',
    'branchId',
    'widgetsUrlOverride',
    'viewerPlatformOverrides',
    'overridePlatformBaseUrls',
    'thunderboltTag',
    'tpaWidgetUrlOverride',
    'tpasWorkerUrlOverride',
    'disableHtmlEmbeds',
    'suricateTunnelId',
    'inBizMgr',
    'viewerSource',
    'dsOrigin',
    'disableSiteAssetsCache',
    'isEditor',
    'isSantaEditor',
    'disableAutoSave',
    'autosaveRestore',
    'isEdited',
    'ds',
    'ooiInEditorOverrides',
    'localIframeWorker',
    'productionWorker',
    'siteAssetsFallback',
    'editorScriptUrlOverride',
    'tpaSettingsUrlOverride',
    'bobViewerScriptOverride',
    'appRevisionOverride',
    'appDefinitionId',
    'editorSdkSource',
    'EditorSdkSource',
    'origin',
    'dashboardSdkAvailable',
    'dayful',
    'headlessExternalUrls',
    'disableLazyLoading',
    'addAllExperimentsToSled',
    'debugRendering',
    'noExperiments',
    'disableBiLoggerBatch',
    'rc',
    'imageOverlay',
]);
//# sourceMappingURL=queryParamsWhitelist.js.map